import Omer from "../assests/images/omer.png";
import Marie from "../assests/images/marie.png";

const ClientRevData = [
  {
    id: 1,
    userName: "Mr Ellis",
    img: "",
    totalRev: "3 reviews",
    date: "17 November 2024",
    bodyTitle: "Splendid service from Ronan and his colleagues",
    bodyDesc:
      "Had a call from Ronan and his colleague today and was thoroughly happy with the way it was dealt with, very professional from start to finish and both lads are huge assets to your company. If all young people were as polite and courteous as these two the world would be a better place to live, thank you both for your efforts",
    expDate: "17 November 2024",
    rating: 5,
  },
  {
    id: 2,
    userName: "Marie Peberdy",
    img: Marie,
    totalRev: "4 reviews",
    date: "12 Nov 2024",
    bodyTitle: "Do it even if in any doubt",
    bodyDesc:
      "I really didn't like having to talk and go over details with flash backs from the traumatic event the call taker helped me was understanding supportive and empathetic. I'd no idea what I was doing I was directed helped through this.",
    expDate: "12 November 2024",
    rating: 5,
  },
  {
    id: 3,
    userName: "Beth",
    img: "",
    totalRev: "1 reviews",
    date: "7 Nov 2024",
    bodyTitle: "Very helpful",
    bodyDesc:
      "Very helpful lady I spoke to made me feel heard for the first time since my accident. Assena was so helpful and kind finally feel like because of her help I might actually get somewhere close to justice for my injury.",
    expDate: " 06 November 2024",
    rating: 5,
  },
  {
    id: 4,
    userName: "Daniel meggitt",
    img: "",
    totalRev: "1 reviews",
    date: "12 Nov 2024",
    bodyTitle: "Staff were very friendly and…",
    bodyDesc:
      "Staff were very friendly and supportive, sympathetic and so far has been a strught forward process.",
    expDate: "12 November 2024",
    rating: 5,
  },
  {
    id: 5,
    userName: "Keith Holroyd",
    img: "",
    totalRev: "5 reviews",
    date: "6 Nov 2024",
    bodyTitle: "Outstanding service",
    bodyDesc:
      "The lady i spoke too initially was polite, friendly and professional. She explained every step in detail so i got a good understanding of what is going to happen.",
    expDate: "06 November 2024",
    rating: 5,
  },
  {
    id: 6,
    userName: "ADE",
    img: "",
    totalRev: "1 reviews",
    date: "28 Oct 2024",
    bodyTitle: "He was very friendly",
    bodyDesc:
      "He was very friendly, professional. Very patient and sympathetic on the phone, I could understand what he was saying as he spoke very clearly. The questions he asked were relevant and he explained everything as we went along. He progressed my call to the appropriate solicitor to deal with my enquiry. Thank you Noor",
    expDate: "28 October 2024",
    rating: 5,
  },
  {
    id: 7,
    userName: "Dionne Clarke",
    img: "",
    totalRev: "19 reviews",
    date: "7 days ago",
    bodyTitle: "Very prompt in answering phone,polite…",
    bodyDesc: "Very prompt in answering phone,polite and easy to understand",
    expDate: " 13 November 2024",
    rating: 5,
  },
  {
    id: 8,
    userName: "Ella",
    img: "",
    totalRev: "2 reviews",
    date: "5 Nov 2024",
    bodyTitle: "Customer service assistant skills were great",
    bodyDesc:
      "Customer service assistant explained what would happen and how they could help they took information which was needed for them to roughly get an idea of what's happened to me he was friendly polite and understanding",
    expDate: " 05 November 2024",
    rating: 5,
  },
  {
    id: 9,
    userName: "OMER RAGIALLA",
    img: Omer,
    totalRev: "10 reviews",
    date: "29 Oct 2024",
    bodyTitle: "The compensation experts are the best…",
    bodyDesc:
      "The compensation experts are very professional. They are very considerate , understanding and empathetic. They gave the impression that they are family or best friends. They would listen to me , ask very relevant questions and explain things in a very clear language.",
    expDate: " 28 October 2024",
    rating: 5,
  },
  {
    id: 10,
    userName: "Lauren Sutcliffe",
    img: "",
    totalRev: "3 reviews",
    date: "17 Oct 2024",
    bodyTitle: "I had a great time with this company",
    bodyDesc:
      "With my accident last year the gentleman on the phone was really helpful with everything he was very mindful with everything. Made me feel heard about with how it's changed my life completely couldn't thank them enough",
    expDate: "17 October 2024",
    rating: 5,
  },
  {
    id: 11,
    userName: "Diana Melarkey",
    img: "",
    totalRev: "10 reviews",
    date: "12 Sept 2024",
    bodyTitle: "Lisa was very understanding,..",
    bodyDesc:
      "Mine is a rather complicated case, and until recently I wasn't even aware that I could / should make a claim. She was very patient and listened well. It was confirmed l would be allocated to a specialist solicitor, and felt more confident about making a claim.",
    expDate: "11 September 2024",
    rating: 5,
  },
];
export { ClientRevData };
